<template>
  <el-dialog
    title="App精研产品设置"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="sort-container">
      <div class="product-lists">
        <div class="product-list left-list">
          <h3>非精研产品</h3>
          <ul>
            <li v-for="(item, index) in normalProductData" :key="item.id" class="product-item">
              <span class="item-name">{{ item.product_name }}</span>
              <span class="item-actions">
                <span class="action-btn" @click="moveToRefined(index)" title="移到精研产品">&rarr;</span>
              </span>
            </li>
          </ul>
        </div>
        
        <div class="product-list right-list">
          <h3>App精研产品</h3>
          <ul>
            <li v-for="(item, index) in sortProductData" :key="item.id" class="product-item">
              <span class="item-name">{{ item.product_name }}</span>
              <span class="item-actions">
                <span class="action-btn" @click="moveToNormal(index)" title="移到非精研产品">&larr;</span>
                <span 
                  class="action-btn up-btn" 
                  @click="moveUp(index)" 
                  v-if="index !== 0"
                  title="上移"
                >&larr;</span>
                <span 
                  class="action-btn down-btn" 
                  @click="moveDown(index)"
                  v-if="index !== sortProductData.length - 1"
                  title="下移"
                >&rarr;</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getProductList, saveAppProductIcon } from '@/api/custom-frontend'

export default {
  name: 'AppProductSortDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saveLoading: false,
      normalProductData: [], // 非精研产品
      sortProductData: []    // App精研产品
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadProductList()
      }
    }
  },
  methods: {
    async loadProductList() {
      if (!this.appInfo.id) return
      
      try {
        const res = await getProductList({
          app_id: this.appInfo.id
        })
        
        if (res && res.err_code === 0) {
          const products = res.rows || []
          
          // 清空数组
          this.normalProductData = []
          this.sortProductData = []
          
          // 根据 index_sort 字段分类产品
          products.forEach(product => {
            if (product.index_sort && product.index_sort !== 0) {
              this.sortProductData.push(product)
            } else {
              this.normalProductData.push(product)
            }
          })
          
          // 对精研产品按 index_sort 排序
          this.sortProductData.sort((a, b) => a.index_sort - b.index_sort)
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
        this.$message.error('获取产品列表失败')
      }
    },
    
    // 移动到精研产品
    moveToRefined(index) {
      const product = this.normalProductData.splice(index, 1)[0]
      this.sortProductData.push(product)
    },
    
    // 移动到非精研产品
    moveToNormal(index) {
      const product = this.sortProductData.splice(index, 1)[0]
      this.normalProductData.push(product)
    },
    
    // 上移
    moveUp(index) {
      if (index === 0) return
      const product = this.sortProductData.splice(index, 1)[0]
      this.sortProductData.splice(index - 1, 0, product)
    },
    
    // 下移
    moveDown(index) {
      if (index === this.sortProductData.length - 1) return
      const product = this.sortProductData.splice(index, 1)[0]
      this.sortProductData.splice(index + 1, 0, product)
    },
    
    async handleSave() {
      // 检查精研产品数量限制
      if (this.sortProductData.length !== 6) {
        this.$message.error('精研产品只支持6个！')
        return
      }
      
      this.saveLoading = true
      
      try {
        const productIds = this.sortProductData.map(product => product.id)
        
        // 调用保存接口
        const res = await saveAppProductIcon({
          app_product_ids: productIds,
          app_id: this.appInfo.id
        })
        
        if (res.err_code === 0) {
          this.$message.success('保存成功')
          this.handleClose()
          this.$emit('refresh')
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.saveLoading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.sort-container {
  padding: 20px 0;
  
  .product-lists {
    display: flex;
    justify-content: space-around;
    gap: 20px;
    
    .product-list {
      width: 280px;
      height: 320px;
      border: 1px dashed #ccc;
      border-radius: 5px;
      padding: 10px 0;
      box-sizing: border-box;
      overflow: auto;
      
      h3 {
        color: #409eff;
        text-align: center;
        margin: 0 0 10px 0;
        padding: 0 10px;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
      }
      
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        .product-item {
          height: 24px;
          line-height: 24px;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          &:hover {
            background: #eee;
          }
          
          .item-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
            margin-right: 10px;
          }
          
          .item-actions {
            display: flex;
            gap: 2px;
            
            .action-btn {
              display: inline-block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #fff;
              background: #409eff;
              border-radius: 3px;
              cursor: pointer;
              font-size: 12px;
              
              &:hover {
                background: #00A1CB;
              }
              
              &.up-btn {
                transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
              }
              
              &.down-btn {
                transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
              }
            }
          }
        }
      }
    }
  }
}
</style>